<!--
右下角浮动按钮
最近更新：20200318
-->
<template>
<div class="float_tools">

  <router-link class="btn btn_backhome" title="回到首页" :to="backhomeUrl" v-show="innerShowBackhome"><i class="material-icons">&#xe88a;</i></router-link>
  <!--
  <router-link class="btn btn_cart" title="购物车" to="/cart" v-show="innerShowCart"><i class="material-icons">&#xe547;</i><em class="badge badge_color_1" v-show="cartCount">{{cartCount}}</em></router-link>
  -->
  <!--<a class="btn btn_back" title="返回上一页" @click="funBack"><i class="material-icons">&#xe5c4;</i></a>
  <a class="btn btn_refresh" title="刷新页面" @click="funReload"><i class="material-icons">&#xe5d5;</i></a>-->
  <slot name="extra">
  </slot>
</div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'FloatTools',
  components: {},
  props: ['showBackhome', 'showCart'],
  data () {
    return {
      innerShowBackhome: true,
      innerShowCart: true,
      backhomeUrl: '/',
      //tmpName: 'FloatTools',
    }
  },
  computed: {
    ...mapState({
      cartCount: state => state.cartCount
    }),
  },
  watch: {},
  created() {
    const _this = this;
/*     if( _this.GLOBAL.loginUser.roletype != 2 ) {
      _this.funForceUpdate();//拉取购物车商品数量
    } else {
      _this.backhomeUrl = '/me';
    } */

    //是否显示【回首页】
    if( typeof _this.showBackhome != 'undefined' ){
      if( _this.showBackhome ){
        _this.innerShowBackhome = true;
      } else {
        _this.innerShowBackhome = false;
      }
    }

    //是否显示【购物车】
    if( typeof _this.showCart != 'undefined' ){
      if( _this.showCart ){
        _this.innerShowCart = true;
      } else {
        _this.innerShowCart = false;
      }
    }
    //总部角色不显示【购物车】
    //if( _this.GLOBAL.loginUser.roletype == 2 ) _this.innerShowCart = false;

  },
  mounted() {
  },
  destroyed() {},
  methods: {
    funBack(){
      this.$router.go(-1);
    },
    funReload(){
      location.reload(true);
    },
    //拉取购物车商品数量，并强制刷新
    funForceUpdate(){
      const _this = this;
/*       _this.getCartCount(function(){
        _this.$forceUpdate();
      });//拉取购物车商品数量 */
    },
  }
}
</script>

<style lang="less">
/** 右下角浮动按钮 通用 **/
.float_tools {
  display: block;
  position: fixed;
  right: 10px;
  bottom: 60px;
  z-index: 10;
  font-size: 0;
  width: 40px;
}
.float_tools .btn {
  border-radius: 100px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  opacity: .9;
  background-color: #333;
  color: #fff;
  margin-top: 5px;
  position: relative;
}
.float_tools .btn > .material-icons {
  line-height: inherit;
  vertical-align: top;
}
.float_tools .btn:hover {
  opacity: 1;
}
.float_tools .btn > .badge {
  position: absolute;
  padding: 0 4px;
  min-width: 24px;
  text-align: center;
  border-radius: 100px;
  transform: scale(0.8);
  top: -5px;
  left: 50%;
  margin-left: 5px;
}
.float_tools .btn_scroll_to_top {
  display: none;
}
.float_tools .btn_scroll_to_top.active {
  display: block;
  -webkit-animation: scroll_to_top_ani .3s ease-out;
  animation: scroll_to_top_ani .3s ease-out ;
}

@-webkit-keyframes scroll_to_top_ani {
  0% {
    -webkit-transform: scale(0);
  }
  80% {
    -webkit-transform: scale(1.2);
  }
  100% {
    -webkit-transform: scale(1);
    opacity: .8;
  }
}

@keyframes scroll_to_top_ani {
  0% {
    transform: scale(0);
  }
  80% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.float_tools .btn_backhome {
  background-color: #0081e7;
}
.float_tools .btn_cart {
  /*background-color:#ff7e00;*/
}
.float_tools .btn_favorite {
  background-color: rgba(239, 58, 58, .5);
  text-shadow: 0 0 10px #ef3a3a;
  box-shadow: inset 0 0 20px rgba(239, 58, 58, .5);
}
.float_tools .btn_favorite.active {
  background-color: #ef3a3a;
  color: #fff;
  text-shadow: none;
}
.float_tools .btn_favorite.active .no,
.float_tools .btn_favorite .ok {
  display: none;
}
.float_tools .btn_favorite.active .ok {
  display: inline-block;
}
.float_tools .btn_favorite.active {
  -webkit-animation: scroll_to_top_ani .3s ease-out;
  animation: scroll_to_top_ani .3s ease-out ;
}
</style>



// WEBPACK FOOTER //
// src/components/FloatTools.vue